import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { getDeviceChiamataEffettuate } from "../../../const/CardDati";
import { useEffect, useState } from "react";
import axios from "axios";
import Style from "./chart.module.css";
import { Line } from "react-chartjs-2";
import { DataToObjChartDurataDevice } from "../../../functions/DataToObjChart";
import { chartOptions } from "../../../const/chartOptions";
import Divider from "@mui/material/Divider";
import { Grid, Skeleton } from "@mui/material";
import { CDCard, CDCardContent, CDCardHeader } from "../../../const/CDCardStyles";
import IconTooltip from "../Tooltip/Tooltip";
import {chartDeviceChiamateTexts} from "../../../const/CardTexts";
import { useDispatch } from 'react-redux';
import {notificationOpen}  from "../../../redux/reducers/notification-reducer";
import handlerError from "../../../functions/handlerError";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const urlBase = process.env.REACT_APP_URL;
const DateComponent = getDeviceChiamataEffettuate;


const ChartDeviceChiamate = ({ dataPicker, refresh, deviceFilter }) => {
  const dispatch = useDispatch();
  const [isFetching, setIsFetching] = useState(false);
  const [chartData, setChartData] = useState();

  useEffect(() => {
    (async () => {
      if ( deviceFilter.length != 1) {
        setIsFetching(true);
        const { startDate, endDate } = dataPicker;
        const { action, method } = DateComponent;
        const body = { startDate, endDate, deviceId: deviceFilter };
        let url = urlBase + action;
        try {
          const response = await axios({
            method: method,
            url,
            data: body,
          });
          const responseToChartData = DataToObjChartDurataDevice(response.data);
          if (Object.keys(responseToChartData).length !== 0) {
            setChartData(responseToChartData);
          }
        } catch(error){
          console.error(error);
          const notificationError = handlerError(error)
          dispatch(notificationOpen(notificationError))
        } 
        setIsFetching(false);
      }
    })();
  }, [refresh, dataPicker, deviceFilter]);
  
  return (
    <>
  {deviceFilter.length != 1 && (
    <Grid item xs={12} sm={12}>
      <CDCard>     
      {deviceFilter.length != 1 ? (
        !isFetching ? (
          chartData && (
          <>
            <CDCardHeader title={
              <IconTooltip data={chartDeviceChiamateTexts} />
            } />
            <Divider />
            <CDCardContent className={Style.cardContent}>
              <Line
                options={chartOptions}
                data={chartData}
                className={Style.container}
              />
            </CDCardContent>
          </>
          )
        ) : ( 
          <>
            <CDCardHeader title={
              <IconTooltip data={chartDeviceChiamateTexts} />
            } />
            <Divider/>
            <CDCardContent className={Style.cardContent}>
              <span><Skeleton variant="rectangular" height={960} /></span>
            </CDCardContent>
          </>
        )
        ) : (
          <>          
          </>
        )}
      </CDCard>
    </Grid>
  )}
  </>
  );
};

export default ChartDeviceChiamate;
